import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import { AutorizacionesAccordionMateriales } from "./Accordions/AutorizacionesAccordionMateriales";
import LetterX from "../UI/LetterX";
import {
  deletePractica,
  setearValorEnPractica,
} from "../../../actions/autorizaciones/Autorizaciones";
import { AUTORIZACIONES_BANDEJAS, AUTORIZACIONES_PRESUPUESTOS_ESTADOS } from "../../../utils/constants";

export const PracticaTipoSolPresupuesto = (props) => {
  const dispatch = useDispatch();

  const { presupuestoSeleccionado = {} } = useSelector(
    (state) => state.autorizaciones
  );

  console.log("Aaaa", presupuestoSeleccionado);

  const disabledProp = (/*props.desdeAuditar ||*/
    props.disabled) ? true : false;

  const disabledValorUni = (presupuestoSeleccionado.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.COMPRAS
    && presupuestoSeleccionado.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE
  ) ? false : props.disabled;

  return (
    <div /* style={{ marginBottom: "2.8rem" }} */>
      <div
        style={{
          padding: "1rem",
          marginTop: "1.5rem",
          marginBottom: "0.5rem",
          marginRight: "1rem",
          marginLeft: "1rem",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {!disabledProp && (
          <LetterX
            deleteFunction={() => {
              dispatch(deletePractica(props.practica?.idCodNom));
            }}
            styles={{
              cursor: "pointer",
              position: "relative",
              top: "0.25rem",
              marginRight: "0.5rem",
            }}
          />
        )}
        <Typography
          variant="h6"
          style={{
            flexGrow: 1,
            fontSize: "1.1rem",
            width: "75%", // Ajusta este valor según el tamaño deseado
            wordWrap: "break-word" // Asegura que las palabras largas también se ajusten a las líneas
          }}
        >
          {`${props.practica?.practica?.codNom} - ${props.practica?.practica?.desNom}`}
        </Typography>
        <TextField
          style={{
            width: props.desdeAuditar ? "12%" : "8%",
            position: "relative",
            bottom: "1.2rem",
            right: "1.0rem",
            marginRight: "1.0rem",
          }}
          variant="outlined"
          type="number"
          label="Cantidad"
          value={props.cantidad}
          disabled={disabledProp}
          onChange={(e) => {
            props.setCantidad(e.target.value);
            dispatch(
              setearValorEnPractica(
                props.practica?.idCodNom,
                "cant",
                Number(e.target.value)
              )
            );
          }}
          error={props.cantidad <= 0}
          helperText={props.cantidad <= 0 && "Debe ser mayor a 0."}
        />
        {props.desdeAuditar && (presupuestoSeleccionado.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.COMPRAS ||
          presupuestoSeleccionado.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE_CONTRATOS ||
          presupuestoSeleccionado.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
        ) &&
          <TextField
            style={{
              width: props.desdeAuditar ? "22%" : "18%",
              position: "relative",
              bottom: "1.2rem",
            }}
            variant="outlined"
            type="number"
            label="Valor Uni."
            value={props.valorUnitario}
            disabled={disabledValorUni}
            onChange={(e) => {
              props.setValorUnitario(e.target.value);
              dispatch(
                setearValorEnPractica(
                  props.practica?.idCodNom,
                  "valorUnitario",
                  Number(e.target.value)
                )
              );
            }}
          //error={props.valorUnitario <= 0}
          //helperText={props.valorUnitario <= 0 && "Debe ser mayor a 0."}
          />}
      </div>
      {/* {props.desdeAuditar && ( */}
      <React.Fragment>
        <FormGroup>
          <FormControlLabel
            style={{
              marginLeft: 20,
              marginTop: -20,
              marginBottom: 25,
            }}
            control={
              <Checkbox
                checked={!!props.practica?.recuperoSur}
                disabled={!props.desdeAuditar ||
                  presupuestoSeleccionado.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE}
                onChange={(e) => {
                  dispatch(
                    setearValorEnPractica(
                      props.practica?.idCodNom,
                      "recuperoSur",
                      e.target.checked
                    )
                  );
                }}
              />
            }
            label="SURGE"
          />
        </FormGroup>
      </React.Fragment>
      {/* )} */}
      {props.mostrarMateriales && (
        <AutorizacionesAccordionMateriales
          estaCorrecto={true}
          noMostrarEstado={true}
          practica={props.practica}
          disabled={props.disabled}
          desdeAuditar={props.desdeAuditar}
          idTipoSolicitud={presupuestoSeleccionado?.idTipoSolicitud}
        />
      )}
    </div>
  );
};